import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-px-4 tw-py-3 tw-font-medium tw-text-slate-900 tw-whitespace-nowrap" }
const _hoisted_2 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_3 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-indigo-500/15 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-indigo-800"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-indigo-500/15 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-indigo-800"
}
const _hoisted_5 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-amber-500/15 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-amber-800"
}
const _hoisted_6 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_7 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_8 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-px-2.5 tw-py-1 tw-font-medium tw-text-slate-700"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-px-2.5 tw-py-1 tw-font-medium tw-text-slate-700"
}
const _hoisted_10 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_11 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_12 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_13 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_14 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_15 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }
const _hoisted_16 = { class: "tw-px-4 tw-py-3 tw-whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TripTypeField = _resolveComponent("TripTypeField")!

  return (_ctx.container && _ctx.container.order)
    ? (_openBlock(), _createElementBlock("tr", {
        key: 0,
        class: "tw-cursor-zoom-in odd:tw-bg-slate-50/40 hover:tw-bg-slate-900/5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTripStatus(_ctx.container.id)))
      }, [
        _createElementVNode("td", _hoisted_1, [
          _createVNode(_component_CopyButton, {
            value: _ctx.container.containerId,
            mode: "wrap-content",
            title: "Copy container number",
            "aria-label": "Copy container number to clipboard"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.container.containerId), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("td", _hoisted_2, [
          (_ctx.container.order.orderType && _ctx.container.order.orderType.includes('Import'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Import "))
            : (_ctx.container.order.orderType && _ctx.container.order.orderType.includes('Rail'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Rail "))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, " Export "))
        ]),
        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.container.size) + _toDisplayString(_ctx.container.type), 1),
        _createElementVNode("td", _hoisted_7, [
          (_ctx.container.order?.isExport)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createVNode(_component_CopyButton, {
                  value: _ctx.container.order?.bookingNumber,
                  mode: "wrap-content",
                  title: "Copy booking number",
                  "aria-label": "Copy booking number to clipboard"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.container.order?.bookingNumber), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : (_ctx.container.order?.billOfLading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_CopyButton, {
                    value: _ctx.container.order?.billOfLading?.billOfLadingId,
                    mode: "wrap-content",
                    title: "Copy bill of lading number",
                    "aria-label": "Copy bill of lading number to clipboard"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.container.order?.billOfLading?.billOfLadingId), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.nextTripForContainers && _ctx.nextTripForContainers.origin ? _ctx.nextTripForContainers.origin.name : ''), 1),
        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.nextTripForContainers && _ctx.nextTripForContainers.destination ? _ctx.nextTripForContainers.destination.name : ''), 1),
        _createElementVNode("td", _hoisted_12, [
          (_ctx.nextTripForContainers)
            ? (_openBlock(), _createBlock(_component_TripTypeField, {
                key: 0,
                showLabel: false,
                trip: _ctx.nextTripForContainers,
                isEditing: false,
                darkGreen: _ctx.nextTripForContainers.status == 'Complete',
                gray: 
          _ctx.nextTripForContainers.status != 'Complete' &&
          _ctx.nextTripForContainers.status != 'In Progress'
        ,
                green: _ctx.nextTripForContainers.status == 'In Progress'
              }, null, 8, ["trip", "darkGreen", "gray", "green"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.nextTripForContainers && _ctx.nextTripForContainers.driver ? _ctx.nextTripForContainers.driver.fullName : ''), 1),
        _createElementVNode("td", _hoisted_14, [
          (_ctx.nextTripForContainers)
            ? (_openBlock(), _createBlock(_component_CopyButton, {
                key: 0,
                value: _ctx.nextTripForContainers.chassis,
                mode: "wrap-content",
                title: "Copy chassis number",
                "aria-label": "Copy chassis number to clipboard"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nextTripForContainers.chassis), 1)
                ]),
                _: 1
              }, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.container.order?.billTo?.name || ''), 1),
        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.container.order?.receiver?.name || ''), 1)
      ]))
    : _createCommentVNode("", true)
}